import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { getDocument, getWindow } from 'ssr-window';

import activePin from '@/assets/images/pin-active.svg';
import hoverPin from '@/assets/images/pin-hover.svg';
import standardPin from '@/assets/images/pin-standard.svg';
import { trackInteraction } from '@/utils/analytics';

const window = getWindow();
const document = getDocument();

const buildSinglePin = (key) => {
    const pin = document.createElement('div');
    pin.className = 'single-marker';
    pin.setAttribute('data-map-marker-key', key);
    pin.setAttribute('data-trigger', 'location');

    const active = document.createElement('img');
    active.src = activePin;
    active.className = 'pin active';
    pin.appendChild(active);

    const standard = document.createElement('img');
    standard.src = standardPin;
    standard.className = 'pin standard';
    pin.appendChild(standard);

    const hover = document.createElement('img');
    hover.src = hoverPin;
    hover.className = 'pin hover';
    pin.appendChild(hover);

    return pin;
};
const buildClusterPin = (count) => {
    const cluster = document.createElement('div');
    cluster.innerHTML = `<span class='cluster-marker__count type-t2'>${count}</span>`;
    cluster.className = 'cluster-marker';
    return cluster;
};

let markerClusterer = null;
let markers = [];

export const addClusterMarkers = async ({ map, items, setCurrentKey, analytics }) => {
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
    const renderer = {
        render: ({ count, position }) => {
            const cluster = new AdvancedMarkerElement({
                title: count.toString(),
                position: position,
                content: buildClusterPin(count),
                zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count, // adjust zIndex to be above other markers
            });
            cluster.addListener('click', (event) => {
                event.domEvent.stopPropagation();
                event.domEvent.preventDefault();
                setCurrentKey(null);
            });
            return cluster;
        },
    };

    const newMarkers = items.map((item) => {
        const marker = new AdvancedMarkerElement({
            position: item.position,
            map,
            content: buildSinglePin(item.key),
        });

        marker.addListener('click', ({ domEvent }) => {
            domEvent.preventDefault();
            domEvent.stopPropagation();
            setCurrentKey(item.key);
            map.panTo(item.position);

            if (analytics) {
                trackInteraction({
                    ...analytics,
                    ...item.itemAnalytics,
                });
            }
        });

        return marker;
    });

    if (!markerClusterer) {
        markerClusterer = new MarkerClusterer({
            markers: newMarkers,
            map,
            renderer,
            algorithmOptions: {
                radius: 100, // cluster size
            },
        });
    } else {
        markerClusterer.removeMarkers(markers, true);

        markerClusterer = new MarkerClusterer({
            markers: newMarkers,
            map,
            renderer,
            algorithmOptions: {
                radius: 100, // cluster size
            },
        });
    }

    markers = newMarkers;

    return () => {
        if (markerClusterer && markers.length > 0) {
            markerClusterer.removeMarkers(markers, true);
            markerClusterer.render();
        }
    };
};
